// CSS Modules - component class name prefix: ResultFilter__

<template>
  <div
    v-if="results.length !== 0"
    :class="[$style.container, 'columns is-multiline is-mobile']"
  >
    <div ref="topAnchor" :class="$style.topAnchor"></div>
    <div
      v-for="(filter, index) in filters"
      :key="index"
      :class="[$style.filter, 'column is-half-mobile is-full-tablet']"
    >
      <a
        :ref="filter.name"
        :class="[
          $style.content,
          { ResultFilter__filterActive: currentFilter === filter.name }
        ]"
        @click="startNewSearch(filter.name)"
      >
        <span v-if="filter.label">{{ filter.label | capitalize }}</span>
        <span>({{ filter.hits }})</span>
      </a>
    </div>
    <a @click="scrollToAndReset" :class="[$style.reset, 'column is-full']">
      {{ filterResetText }}
      <div ref="bottomAnchor" :class="$style.bottomAnchor"></div>
    </a>
  </div>
</template>

<script>
import smoothscroll from "smoothscroll-polyfill";
import getSearchResultFromUrl from "../../xhr/search/getSearchResultFromUrl";

smoothscroll.polyfill();

export default {
  name: "ResultFilter",
  props: {
    filterResetText: {
      type: String,
      default: ""
    },
    results: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    terms: {
      type: Array,
      default: () => []
    },
    rangeSize: {
      type: Number
    }
  },
  data() {
    return {
      currentFilter: null,
      filteredResults: [],
      useCategorySearch: false,
      range: {
        from: 0
      },
      loading: false,
      totalReached: false,
      isMobile: false,
      searchContainer: window.searchContainer,
      disableExternalDocuments: window.disableExternalDocuments
    };
  },
  filters: {
    capitalize: function(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    initScroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollHeight - window.innerHeight ===
          window.pageYOffset;
        if (
          bottomOfWindow &&
          !this.loading &&
          this.useCategorySearch &&
          !this.totalReached
        ) {
          this.range.from = this.range.from + this.rangeSize;
          this.getSearchResults(this.currentFilter, true);
        }
      };
    },
    startNewSearch(category) {
      if (this.currentFilter === category) {
        return;
      }
      this.range.from = 0;
      this.useCategorySearch = true;
      this.totalReached = false;
      this.checkScreenSize();
      if (this.isMobile) {
        this.$refs.bottomAnchor.scrollIntoView({ behavior: "smooth" });
      }
      this.getSearchResults(category);
    },
    getSearchResults(category, onScroll) {
      this.loading = true;
      this.currentFilter = category;

      getSearchResultFromUrl(window.categorySearchUrl, {
        word: this.terms,
        from: this.range.from,
        size: this.rangeSize,
        container: this.searchContainer,
        disableExternalDocuments: this.disableExternalDocuments,
        categoryuid: category
      })
        .then(responseData => {
          if (onScroll) {
            this.filterResults(responseData, true);
          } else {
            this.filterResults(responseData);
          }
        })
        .catch(error => console.error(error));
    },
    filterResults(data, update) {
      if (update) {
        this.filteredResults.push(...data.hits.hits);
      } else {
        this.filteredResults = data.hits.hits;
        this.initScroll();
      }

      this.loading = false;

      for (const filter of this.filters) {
        if (
          this.currentFilter === filter.name &&
          this.filteredResults.length === filter.hits
        ) {
          this.totalReached = true;
        }
      }
      this.$emit("filtered", this.filteredResults);
    },
    scrollToAndReset() {
      this.checkScreenSize();
      if (this.isMobile) {
        this.$refs.topAnchor.scrollIntoView({ behavior: "smooth" });
      }
      this.resetFilters();
    },
    resetFilters() {
      this.currentFilter = null;
      this.filteredResults = this.results;
      this.useCategorySearch = false;
      this.$emit("filtered", this.filteredResults);
    }
  },
  watch: {
    terms: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetFilters();
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./ResultFilter.scss";
</style>
